/** Store URLs — set in .env as REACT_APP_ANDROID_APP_URL / REACT_APP_IOS_APP_URL */
export const MOBILE_APP = {
  androidUrl: (process.env.REACT_APP_ANDROID_APP_URL || "").trim(),
  iosUrl: (process.env.REACT_APP_IOS_APP_URL || "").trim(),
  supportEmail: "support@nextfollowup.in",
  supportWhatsApp: "7009089235",
  supportWhatsAppDisplay: "+91 70090 89235",
};

export const MOBILE_APP_FEATURES = [
  { icon: "fas fa-map-marker-alt", label: "Geo attendance check-in" },
  { icon: "fas fa-bell", label: "Lead & follow-up alerts" },
  { icon: "fas fa-tasks", label: "Assigned leads on the go" },
];
